import ArticleLayout from '@/components/feature/ArticleLayout';
import { tipsArticle } from '@/mocks/tipsArticle';

export default function HipobuySpreadsheetTips() {
  return <ArticleLayout article={tipsArticle} slug="hipobuy-spreadsheet-tips" />;
}